<template>
        <v-autocomplete
                v-model="model"
                :items="data"
                :label="label"
                :loading="loading"
                :search-input.sync="search"
                :full-width="true"
                clearable
                chips
                deletable-chips
                item-value="id"
                item-text="label"
                multiple
                color="primary"
                placeholder="Start typing to Search"
        >
            <v-slide-x-reverse-transition
                    slot="append-outer"
                    mode="out-in"
            >
                <v-icon
                        :key="`icon-${isEditing}`"
                        :color="isEditing ? 'success' : 'info'"
                        @click="isEditing = !isEditing"
                        v-text="isEditing ? 'mdi-check-outline' : 'mdi-circle-edit-outline'"
                ></v-icon>
            </v-slide-x-reverse-transition>
        </v-autocomplete>
</template>

<script>
    // Friendly, self-explanatory labels for the cryptic permission codes so
    // admins can tell what each one grants (e.g. the transfer-center agent).
    const PERMISSION_LABELS = {
        BOOKINGS: "Bookings",
        BOOKING_COMPLAINTS: "Booking complaints",
        TRACKING: "Live tracking",
        STAFF: "Staff (employees)",
        ROLES: "Roles & permissions",
        DRIVERS: "Drivers (captains)",
        PASSENGERS: "Passengers",
        ACCOUNTING: "Accounting",
        STATISTICS: "Statistics / dashboard",
        MARKETING_VOUCHERS: "Marketing vouchers",
        PERSONAL_VOUCHERS: "Personal vouchers",
        PASSENGERS_MARKETING: "Passengers marketing",
        SERVICES: "Services",
        CANCELLATION_REASONS: "Cancellation reasons",
        CAR_BRANDS: "Car brands",
        CAR_COLORS: "Car colors",
        SETTINGS: "Settings",
        ZONES: "Zones / areas",
        PAYMENT_METHODS: "Payment methods",
        TRANSFER_CENTERS: "Charge centers (manage + accounting)",
        TRANSFER_AGENT: "Charge-center agent — recharge centers / collect cash",
        CAR_OWNERS: "Car owners (ride-revenue balances)",
        BUSINESS_ACCOUNTS: "Business wallets (B2B prepaid balances)",
        // Owner item 2.1: the restricted captain welcome balance.
        WELCOME_BONUS_MANAGE: "Welcome balance: set a captain's amount, close the remainder (finance manager)",
        WELCOME_BONUS_APPROVE: "Welcome balance: approve closures above the threshold (general manager)",
        VIEW_CAPTAIN_LEDGER: "View captain ledger",
        SETTLE_CAPTAIN_BALANCE: "Settle captain balance",
        SETTLEMENTS: "Settlements",
        VIEW_FINANCE_REPORTS: "Finance reports",
        VIEW_FINANCE_SUMMARY: "Finance summary",
        MANAGE_FINANCE_ACCOUNTS: "Finance: manage accounts",
        MANAGE_FINANCE_ADJUSTMENTS: "Finance: adjustments",
        MANAGE_FINANCE_JOURNALS: "Finance: journals",
        REVERSE_FINANCE_JOURNALS: "Finance: reverse journals",
        MANAGE_POSTING_RULES: "Finance: posting rules (auto entries)",
        CREATE_BOOKING: "Create booking",
        CARLO_PAYMENT: "Carlo payment",
    };

    function humanize(name) {
        return String(name || "")
            .toLowerCase()
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase());
    }

    function normalizePermissions(payload) {
        let list = [];
        if (Array.isArray(payload)) list = payload;
        else if (payload && Array.isArray(payload.data)) list = payload.data;
        return list.map((p) => ({
            ...p,
            label: `${PERMISSION_LABELS[p.name] || humanize(p.name)} (${p.name})`,
        }));
    }

    export default {
        name: "choose-permissions-multi",
        props: ['label', 'value'],
        data() {
            return {
                isEditing: false,
                loading: false,
                model: this.value,
                search: null,
                data: [],
                cached: []
            }
        },
        mounted() {
            this.loading = true;
            this.axios.get(this.api.ACTIONS.PERMISSIONS)
                .then(res => {
                    this.data = normalizePermissions(res.data.data);
                })
                .catch(err => console.log(err))
                .finally(() => this.loading = false);
        },
        watch: {
            model(val) {
                this.$emit("input", val);
            }
        },
        methods: {
            remove(id) {
                this.model = this.model.filter(item => item !== id);
            }
        }
    }
</script>

<style scoped>

</style>